<script>

    import { InvoiceClientStore, UserStore } from '../stores'

    import InvoicesService from '../$services/invoices.service'

    import Spinner from '../$components/spinner.svelte'
    import Value from '../$components/value.svelte'

    let loading = false

    getClient()

    async function getClient() {

		loading = true
		const resp = await InvoicesService.getClient($UserStore._id)
		loading = false

		if(!resp.success) 
            return InvoiceClientStore.set(null)

		InvoiceClientStore.set(resp.data)
	}

</script>

<Spinner { loading } />

{#if $InvoiceClientStore}
    <div class="columns">
        <div class="column">
            <Value label="Nombre" value={ $InvoiceClientStore.name } />
        </div>
        <div class="column">
            <Value label="RFC" value={ $InvoiceClientStore.rfc } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Correo" value={ $InvoiceClientStore.email } /> 
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Código Postal" value={ $InvoiceClientStore.location.zipcode } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Estado" value={ $InvoiceClientStore.location.state } /> 
        </div>
        <div class="column">
            <Value label="Ciudad" value={ $InvoiceClientStore.location.city } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Colonia" value={ $InvoiceClientStore.location.colony } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Calle" value={ $InvoiceClientStore.location.street } />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Value label="Número exterior" value={ $InvoiceClientStore.location.number } />
        </div>
        <div class="column">
            <Value label="Número interior" value={ $InvoiceClientStore.location.apartment || 'Sin información' } />
        </div>
    </div>
{/if}